import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Controller } from "react-hook-form";
import { getCfDisplayName } from "@/features/customField/utils/cfDisplayName";
import { useRequiredFieldMark } from "@/features/leads/requirements/requiredFieldMarks";
import { RequiredStar } from "@/features/leads/requirements/requiredFieldMarks.ui";

interface PrefrenceTextFieldProps {
  val: any;
  index: number;
  control: any;
  errors: any;
  isRemark?: boolean;
  readOnly?: boolean;
}

export default function PrefrenceTextField({
  val,
  index,
  control,
  errors,
  isRemark = false,
  readOnly = false,
}: PrefrenceTextFieldProps) {
  // Stage-requirement star (null outside a marks provider → no change).
  const required = useRequiredFieldMark("custom", val?.id);
  return (
    <div
      key={val.id}
      className={`flex flex-col gap-1.5 ${isRemark ? "col-span-2" : "[&:last-child:nth-child(odd)]:col-span-2"}`}
    >
      <Label
        htmlFor={`customInputScopes-${index}`}
        className="text-[#051912] text-sm tracking-[-0.56px] font-normal leading-[1.35]"
      >
        {getCfDisplayName(val)}
        <RequiredStar mark={required} className="-ml-1.5" />
      </Label>

      <Controller
        name={`customInputScopes.${index}`}
        control={control}
        render={({ field }) => {
          const textValue = field.value?.textValue ?? "";

          const handleChange = (newValue: string) => {
            field.onChange({
              customInputId: val.id,
              optionIds: [],
              textValue: newValue,
            });
          };

          if (isRemark) {
            return (
              <Textarea
                id={`customInputScopes-${index}`}
                value={textValue}
                readOnly={readOnly}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={`Enter ${getCfDisplayName(val).toLowerCase()}`}
                rows={3}
                className={`bg-[#fcfcfc] border-[#cdd1d0] rounded-xl px-3 py-2 text-sm w-full resize-none ${
                  readOnly ? "cursor-default opacity-80" : ""
                } ${
                  errors?.customInputScopes?.[index]
                    ? "border-red-500 focus-visible:ring-red-500"
                    : ""
                }`}
              />
            );
          }

          return (
            <Input
              id={`customInputScopes-${index}`}
              value={textValue}
              readOnly={readOnly}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={`Enter ${getCfDisplayName(val).toLowerCase()}`}
              className={`bg-[#fcfcfc] border-[#cdd1d0] h-10 rounded-xl px-3 py-2 text-sm w-full ${
                readOnly ? "cursor-default opacity-80" : ""
              } ${
                errors?.customInputScopes?.[index]
                  ? "border-red-500 focus-visible:ring-red-500"
                  : ""
              }`}
            />
          );
        }}
      />
    </div>
  );
}
